"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Cache = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/entries"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/symbol"));

var _stringHash = _interopRequireDefault(require("string-hash"));

var cacheSymbol = (0, _symbol.default)('__cache_key_cache__');

var Cache = /*#__PURE__*/function () {
  function Cache(max, keyFn) {
    (0, _classCallCheck2.default)(this, Cache);
    this._max = void 0;
    this._store = void 0;
    this._keyFn = void 0;
    this._max = max;
    this._store = new _map.default();
    this._keyFn = keyFn;
  }

  (0, _createClass2.default)(Cache, [{
    key: "_hashKey",
    value: function _hashKey(obj) {
      if (!obj[cacheSymbol]) {
        obj[cacheSymbol] = (0, _stringHash.default)(this._keyFn(obj));
      }

      return obj[cacheSymbol];
    }
  }, {
    key: "get",
    value: function get(obj, zoom) {
      var zooms = this._store.get(this._hashKey(obj));

      return zooms === null || zooms === void 0 ? void 0 : zooms[zoom];
    }
  }, {
    key: "has",
    value: function has(obj, zoom) {
      var zooms = this._store.get(this._hashKey(obj));

      return Boolean(zooms === null || zooms === void 0 ? void 0 : zooms[zoom]);
    }
  }, {
    key: "set",
    value: function set(obj, zoom, value) {
      var key = this._hashKey(obj);

      if (this._store.size >= this._max) {
        this._removeFirst();
      }

      var zooms = this._store.get(key) || {};
      zooms[zoom] = value;

      this._store.set(key, zooms);

      return this;
    }
  }, {
    key: "delete",
    value: function _delete(obj, zoom) {
      var key = this._hashKey(obj);

      if (!this._store.has(key)) {
        return this;
      }

      if (zoom) {
        var zooms = this._store.get(key);

        if (zooms) {
          delete zooms[zoom];

          this._store.set(key, zooms);
        }
      } else {
        this._store.delete(key);
      }

      return this;
    }
  }, {
    key: "_removeFirst",
    value: function _removeFirst() {
      var _context;

      var _iterator = (0, _createForOfIteratorHelper2.default)((0, _entries.default)(_context = this._store).call(_context)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = (0, _slicedToArray2.default)(_step.value, 1),
              _key = _step$value[0];

          this._store.delete(_key);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);
  return Cache;
}();

exports.Cache = Cache;
